<script>
import toaster from "../../common/toaster";
import {
    FormatDateTimeEntryToLocaleString
} from "../../../../utils/date";
import {Screenshot} from "../screenshots/Screenshot";
import ScreenshotDialog from "../screenshots/screenshot-dialog.vue";
import Loading from "../../common/loading.vue";

export default {
    components: {
        Loading,
        ScreenshotDialog
    },
    props: [
        'id',
        'ip',
        'name',
        'connectionDirect',
    ],
    data() {
        return {
            t_image_placeholder: Lang.langGet("No preview available."),
            t_status_load_error: Lang.langGet("Failed to load latest Client status!"),
            t_refresh: Lang.langGet("Refresh"),
            t_restart: Lang.langGet("Last Restarted"),
            t_uptime: Lang.langGet("Uptime"),
            t_cpu_load: Lang.langGet("CPU Load (current / average)"),
            t_output_devices: Lang.langGet("Output Devices"),
            t_output_flags: Lang.langGet("Output Flags"),
            t_resources: Lang.langGet("Resources"),
            t_resources_internal: Lang.langGet("Internal Memory"),
            t_resources_total: Lang.langGet("Total Memory"),
            t_resources_max: Lang.langGet("Max Memory"),
            t_resources_handles: Lang.langGet("Handles"),
            t_resources_gpuhandles: Lang.langGet("GPU Handles"),
            t_resources_userhandles: Lang.langGet("User Handles"),
            t_systemstat: Lang.langGet("System Statistics"),
            t_diskstat: Lang.langGet("Disk Statistics"),
            t_temperature: Lang.langGet("Temperature"),
            t_watchdog: Lang.langGet("Watchdog State"),
            t_screenshot_taken: Lang.langGet("Screenshot taken"),
            t_time_on_device: Lang.langGet("Time on device"),
            t_offline: Lang.langGet("It was not possible to establish a connection to the Server."),
            t_local: Lang.langGet("No current Screenshot available on Server"),
            t_last_connect: Lang.langGet("Last Connect"),
            t_last_local_time: Lang.langGet("Last Local Time"),
            t_last_content: Lang.langGet("Last Content"),
            t_model: Lang.langGet("Model"),
            t_hardware_id: Lang.langGet("Hardware ID"),
            t_hardware_version: Lang.langGet("Hardware Version"),
            t_software_version: Lang.langGet("Software Version"),
            t_screen_status: Lang.langGet("Screen Status"),
            t_mem_status: Lang.langGet("Memory Status"),
            t_storage_status: Lang.langGet("Storage Status"),
            t_network_status: Lang.langGet("Network Status"),
            t_connect_ip: Lang.langGet("IP Address"),

            image_url: '',
            image_timestamp: '',
            time_on_device: null,
            validity: '',
            image_local: false,
            server_offline: false,
            json: {
                uptime: '?',
            },
            is_disabled: false,
            refresh_active: false,
            project_id: Laravel.activeProject,
            loading: false
        }
    },
    computed: {
        t_title: function () {
            return Lang.langGet("Status for \":name\"", {name: this.name})
        },
        t_error() {
            return Lang.langGet('Screenshot could not be retrieved, :host might be offline.', { host: this.name });
        },
        t_critical() {
            return Lang.langGet(':host did not respond for some time.', { host: this.name });
        }
    },
    methods: {
        showScreenshotDlg() {
            const screenshotData = new Screenshot({
                clientId: this.id,
                clientName: this.name,
            })

            EaseEventBus.fire('screenshotDialogShow', screenshotData);
        },
        refresh: function (direct = false) {
            this.loading = true;
            this.refresh_active = true;
            this.image_local = false;
            this.server_offline = false;
            axios.post('/system/client-detail/status', {
                project_id: this.project_id,
                client_mms_id: this.id,
                ip: this.ip,
                direct: direct,
            }).then((response) => {
                this.image_local = response.data.data.local;
                this.server_offline = response.data.data.offline;

                if (direct && response.data.data.json === false) {
                    this.validity = 'sc-error';
                    this.refresh_active = false;
                    return;
                } else {
                    this.validity = response.data.data.validity ?? '';
                }

                if (response.data.data.screenshot === false) {
                    this.image_url = '';
                    this.image_timestamp = '';
                    this.time_on_device = null;
                } else {
                    this.image_url = response.data.data.screenshot;
                    this.image_timestamp = FormatDateTimeEntryToLocaleString(response.data.data.timestamp);
                    this.time_on_device = response.data.data.time_on_device ? FormatDateTimeEntryToLocaleString(response.data.data.time_on_device) : null;
                }

                if (response.data.data.json === false) {
                    this.json = _.extend({}, this.json, {});
                } else {
                    this.json = _.extend({}, this.json, JSON.parse(response.data.data.json));
                }

                if (this.json.hasOwnProperty('last_restart')) {
                    this.json.last_restart = FormatDateTimeEntryToLocaleString(this.json.last_restart);
                }

                this.refresh_active = false;
                if (this.connectionDirect && direct === false) {
                    EaseEventBus.fire('ClientStatusScreenshotLoad');
                }
            }).catch((error) => {
                if (error.response?.status === 401) {
                    window.location = '/login';
                } else if (error.response?.status === 422) {
                    console.log(error.response?.data?.errors);
                }

                toaster.error(this.t_status_load_error);
                this.refresh_active = false;
            })
            .finally(() => {
                this.loading = false;
            });
        }
    },
    mounted() {
        if (this.ip.length === 0 || !this.connectionDirect) {
            this.is_disabled = true;
        }
        this.refresh();
        EaseEventBus.listen('ClientStatusScreenshotLoad', () => {
            this.refresh(true);
        });
    }
}
</script>

<template>
    <div class="ibox screenshot">
        <div class="ibox-content elevation-4" style="border-radius: 8px;">
            <h2 style="margin: 20px;">{{ t_title }}</h2>
            <div class="wrapper">
                <img v-if="image_url.length > 0"
                     :src="image_url"
                     alt=""
                     @click="showScreenshotDlg"
                     class="cursor-pointer"/>
                <div v-if="image_url.length === 0" class="placeholder text-center">
                    {{ t_image_placeholder }}
                </div>
                <div v-if="image_url.length > 0" :class="['row m-xs', validity]">
                    <div class="col-md-5 text-right">{{ t_screenshot_taken }}:</div>
                    <div class="col-md-7">{{ image_timestamp }}</div>
                    <div class="col-md-5 text-right" v-if="time_on_device">{{ t_time_on_device }}:</div>
                    <div class="col-md-7" v-if="time_on_device">{{ time_on_device }}</div>
                </div>
                <div v-if="validity === 'sc-error'" class="row m-xs sc-old text-center bold justify-center">
                    {{ t_error }}
                </div>
                <div v-if="server_offline" class="row m-xs sc-old text-center bold justify-center">
                    {{ t_offline }}
                </div>
                <div v-if="validity === 'sc-medium'" class="row m-xs sc-medium text-center bold justify-center">
                    {{ t_critical }}
                </div>
                <div v-if="image_local && !server_offline" class="row m-xs sc-old text-center bold justify-center">
                    {{ t_local }}
                </div>
                <div class="row" v-if="json.hasOwnProperty('last_restart')">
                    <div class="col-md-5 text-right m-t-sm">{{ t_restart }}:</div>
                    <div class="col-md-7 m-t-sm">{{ json.last_restart }}</div>
                </div>
                <div class="row" v-if="json.hasOwnProperty('uptime')">
                    <div class="col-md-5 text-right">{{ t_uptime }}:</div>
                    <div class="col-md-7">{{ json.uptime }}</div>
                </div>
    <!-- Block for Windows POV clients -->
                <div class="row" v-if="json.hasOwnProperty('cpu_load')">
                    <div class="col-md-5 text-right">{{ t_cpu_load }}:</div>
                    <div class="col-md-7">{{ json.cpu_load }}{{ json.hasOwnProperty('cpu_loadavg') ? ' / ' + json.cpu_loadavg : '' }}</div>
                </div>
                <div class="row" v-if="json.hasOwnProperty('output_devices')">
                    <div class="col-md-5 text-right">{{ t_output_devices }}:</div>
                    <div class="col-md-7" v-html="json.output_devices"></div>
                </div>
                <div class="row" v-if="json.hasOwnProperty('output_flags')">
                    <div class="col-md-5 text-right">{{ t_output_flags }}:</div>
                    <div class="col-md-7">{{ json.output_flags }}</div>
                </div>
                <div class="row" v-if="json.hasOwnProperty('resources')">
                    <div class="col-md-5 text-right pb-0">{{ t_resources }}:</div>
                    <div class="col-md-7 pb-0">
                        <div class="row" v-if="json.resources.hasOwnProperty('internal')">
                            <div class="col-md-12">{{ json.resources.internal }}&nbsp;{{ t_resources_internal }}</div>
                        </div>
                        <div class="row" v-if="json.resources.hasOwnProperty('total')">
                            <div class="col-md-12">{{ json.resources.total }}&nbsp;{{ t_resources_total }}</div>
                        </div>
                        <div class="row" v-if="json.resources.hasOwnProperty('max')">
                            <div class="col-md-12">{{ json.resources.max }}&nbsp;{{ t_resources_max }}</div>
                        </div>
                        <div class="row" v-if="json.resources.hasOwnProperty('handles')">
                            <div class="col-md-12">{{ json.resources.handles }}&nbsp;{{ t_resources_handles }}</div>
                        </div>
                        <div class="row" v-if="json.resources.hasOwnProperty('gpuhandles')">
                            <div class="col-md-12">{{ json.resources.gpuhandles }}&nbsp;{{ t_resources_gpuhandles }}</div>
                        </div>
                        <div class="row" v-if="json.resources.hasOwnProperty('userhandles')">
                            <div class="col-md-12">{{ json.resources.userhandles }}&nbsp;{{ t_resources_userhandles }}</div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="json.hasOwnProperty('systemstat')">
                    <div class="col-md-5 text-right">{{ t_systemstat }}:</div>
                    <div class="col-md-7">{{ json.systemstat }}</div>
                </div>
                <div class="row" v-if="json.hasOwnProperty('diskstat')">
                    <div class="col-md-5 text-right">{{ t_diskstat }}:</div>
                    <div class="col-md-7">{{ json.diskstat }}</div>
                </div>
                <div class="row" v-if="json.hasOwnProperty('temperature')">
                    <div class="col-md-5 text-right">{{ t_temperature }}:</div>
                    <div class="col-md-7">{{ json.temperature }}</div>
                </div>
                <div class="row" v-if="json.hasOwnProperty('watchdog_state')">
                    <div class="col-md-5 text-right">{{ t_watchdog }}:</div>
                    <div class="col-md-7">{{ json.watchdog_state }}</div>
                </div>
    <!-- Block for HTML5 clients -->
                <div class="row" v-if="json.hasOwnProperty('last_connect')">
                    <div class="col-md-5 text-right">{{ t_last_connect }}:</div>
                    <div class="col-md-7">{{ json.last_connect }}</div>
                </div>
                <div class="row" v-if="json.hasOwnProperty('last_local_time')">
                    <div class="col-md-5 text-right">{{ t_last_local_time }}:</div>
                    <div class="col-md-7">{{ json.last_local_time }}</div>
                </div>
                <div class="row" v-if="json.hasOwnProperty('last_content')">
                    <div class="col-md-5 text-right">{{ t_last_content }}:</div>
                    <div class="col-md-7">{{ json.last_content }}</div>
                </div>
                <div class="row" v-if="json.hasOwnProperty('model')">
                    <div class="col-md-5 text-right">{{ t_model }}:</div>
                    <div class="col-md-7">{{ json.model }}</div>
                </div>
                <div class="row" v-if="json.hasOwnProperty('hardware_id')">
                    <div class="col-md-5 text-right">{{ t_hardware_id }}:</div>
                    <div class="col-md-7">{{ json.hardware_id }}</div>
                </div>
                <div class="row" v-if="json.hasOwnProperty('hardware_version')">
                    <div class="col-md-5 text-right">{{ t_hardware_version }}:</div>
                    <div class="col-md-7">{{ json.hardware_version }}</div>
                </div>
                <div class="row" v-if="json.hasOwnProperty('software_version')">
                    <div class="col-md-5 text-right">{{ t_software_version }}:</div>
                    <div class="col-md-7">{{ json.software_version }}</div>
                </div>
                <div class="row" v-if="json.hasOwnProperty('screen_status')">
                    <div class="col-md-5 text-right">{{ t_screen_status }}:</div>
                    <div class="col-md-7">{{ json.screen_status }}</div>
                </div>
                <div class="row" v-if="json.hasOwnProperty('mem_status')">
                    <div class="col-md-5 text-right">{{ t_mem_status }}:</div>
                    <div class="col-md-7">{{ json.mem_status }}</div>
                </div>
                <div class="row" v-if="json.hasOwnProperty('storage_status')">
                    <div class="col-md-5 text-right">{{ t_storage_status }}:</div>
                    <div class="col-md-7">{{ json.storage_status }}</div>
                </div>
                <div class="row" v-if="json.hasOwnProperty('network_status')">
                    <div class="col-md-5 text-right">{{ t_network_status }}:</div>
                    <div class="col-md-7">{{ json.network_status }}</div>
                </div>
                <div class="row" v-if="json.hasOwnProperty('connect_ip')">
                    <div class="col-md-5 text-right">{{ t_connect_ip }}:</div>
                    <div class="col-md-7">{{ json.connect_ip }}</div>
                </div>

                <v-btn v-if="!is_disabled" type="button"
                    v-bind:class="[refresh_active === true ? 'disabled' : '','btn btn-secondary btn-block m-t-sm']"
                    @click.stop.prevent="refresh(true)"
                >
                    <i v-if="refresh_active" class="fa-regular fa-arrows-rotate fa-spin fa-lg fa-fw m-r-xs"></i>
                    <i v-else class="fa-regular fa-arrows-rotate fa-lg fa-fw m-r-xs"></i>
                    {{ t_refresh }}
                </v-btn>
            </div>
        </div>
        <loading :loading="loading" />
        <screenshot-dialog/>
    </div>
</template>

<style scoped>
    .row {
        display: flex;
        flex-wrap: wrap;
        flex: 1 1 auto;
        margin: 0;
    }

    .col-md-5, .col-md-7 {
        padding-top: 6px !important;
        padding-bottom: 6px !important;
    }

    .col-md-12 {
        padding-top: 0 !important;
        padding-left: 0 !important;
    }

</style>
